const ApiURL = "https://email-service.codesour.dev/v1/email";
export const mailSenderService = {
  sendEmail,
  sendEmails,
  sendTemplateEmails,
};

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      switch (response.status) {
        case 401:
          console.error("incorect email or password");
          return Promise.reject({ ...data, statusCode: 401 });
        case 409:
          return Promise.reject({ ...data, statusCode: 409 });
        case 404:
          return Promise.reject(data);
        default:
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function sendEmail(companyMail, subject, message) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      to: companyMail,
      subject: subject,
      message: message,
    }),
  };
  return fetch(ApiURL + `/send_text_email_post`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function sendEmails(companies) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(companies),
  };
  return fetch(ApiURL + `/send_text_email_post_gdpr`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}

function sendTemplateEmails(companies) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(companies),
  };
  return fetch(ApiURL + `/sendEMailConsentTemplate`, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("Errore durante il recupero dei dati:", error);
    });
}
